var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letter-container",class:("letter-" + _vm.status),style:(_vm.defineStyle)},[_c('div',{staticClass:"letter"},[_c('span',{style:(_vm.defineStyle)},[_vm._v(_vm._s(_vm.letter))])])])}
var staticRenderFns = []

export { render, staticRenderFns }